const shapeType = require('../../define/shapeType').default;
const objectType = require('../../define/object').default;
const rotate = require('../../define/rotate').default;
// =============================
// define
const randumSources = [2769, 5863, 4327, 9783, 4836, 6748, 2857, 5728];

const shapeSources = [shapeType.SHAPE_STICK, shapeType.SHAPE_S_LINE, shapeType.SHAPE_CROSS, shapeType.SHAPE_L_LINE, shapeType.SHAPE_RECT];

const porinSources = [objectType.OBJ_BOM_RED, objectType.OBJ_BOM_GREEN, objectType.OBJ_BOM_BLUE, objectType.OBJ_BOM_YELLOW];
// =============================

const getRundumSourceNum = (arrivalStage, selectorCount, randamNum) => {
    return (randumSources[((arrivalStage + randamNum) * selectorCount) % randumSources.length] * arrivalStage) + selectorCount;
}

const getShapeType = num => {
    return shapeSources[(num % shapeSources.length)];
}

const getPorinType = num => {
    return porinSources[(num % porinSources.length)];
}

const getPorins = num => {
    let calcNum = num;
    const porins = [];
    for (let index = 0; index < 4; index++) {
        porins.push(getPorinType(calcNum));
        calcNum = calcNum / porinSources.length | 0;
    }
    return porins;
}


/**
 * return
 * type: shapeType
 * porins: [ object.OBJ_BOM_ ...]
 * rotate: rotate
 */

export const getNextPorinBox = (arrivalStage, selectorCount, rand) => {
    const randNum = getRundumSourceNum(arrivalStage, selectorCount, rand);
    return {
        type: getShapeType(randNum),
        porins: getPorins(randNum),
        rotate: rotate.ROTATE_DEFAULT
    }
}

export const getNextRotate = (current) => {
    switch (current) {
        case rotate.ROTATE_DEFAULT:
            return rotate.ROTATE_90;
        case rotate.ROTATE_90:
            return rotate.ROTATE_180;
        case rotate.ROTATE_180:
            return rotate.ROTATE_270;
        case rotate.ROTATE_270:
            return rotate.ROTATE_DEFAULT;
        default:
            return rotate.ROTATE_DEFAULT;
    }
}